/**
 * Hook que devuelve el contexto completo del usuario actual para los checks
 * de scope (`src/core/auth/scope.ts`).
 *
 * Enriquece el `useAuth()` (email + role) con datos del registro `Usuario`:
 * disciplina (PL/PL2/INT/PLANNER), contratistaId (PLANNER/ADOR) y
 * empresa. Si no se encuentra el registro, devuelve sólo email + role.
 */

import { useMemo } from "react";
import { useAuth } from "./useAuth";
import { useUsuariosActivos } from "@features/autoridades/autoridadesQueries";
import type { UsuarioContexto } from "./scope";

export function useUsuarioContexto(): UsuarioContexto | null {
  const { user } = useAuth();
  const { data: usuarios } = useUsuariosActivos(user?.tenantId ?? "");

  return useMemo<UsuarioContexto | null>(() => {
    if (!user) return null;
    const u = (usuarios ?? []).find((x) => x.email === user.email);
    const ctx: UsuarioContexto = {
      email: user.email,
      role: user.role,
    };
    if (u?.disciplina) ctx.disciplina = u.disciplina;
    if (u?.contratistaId) ctx.contratistaId = u.contratistaId;
    if (u?.empresa) ctx.empresa = u.empresa;
    return ctx;
  }, [user, usuarios]);
}
